// extracted by mini-css-extract-plugin
export default {"Product_page_container":"ProductPage_Product_page_container__TbaKb"};